import React, {useCallback, useState} from 'react';
import moment from 'moment';
import {useMutation, useQueryClient} from 'react-query';
import {toast} from 'react-toastify';
import {rollBackVersion} from '../../../../../requests/queries/flows';
import {useParams} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {PrimaryButton} from '../../../../../components';
import RollbackVersion from '../modals/RollbackFlow';

function VersionLabel({version = {}}) {
  const queryClient = useQueryClient();
  const {user} = useSelector(state => state?.auth);
  const [open, setOpen] = useState(false);
  const {slug} = useParams();

  const currentVersion = version?.updatedAt
    ? moment(version?.updatedAt).format('Do MMM, YYYY : h:m a')
    : 'Version';

  const {mutate: rollBack, isLoading: rollingBack} = useMutation(
    rollBackVersion,
    {
      onSuccess: data => {
        toast.success(
          data.message ||
            `Previous version - Version ${version?.version_number}, restored successfully`,
        );
        queryClient.invalidateQueries('all-tasks');
        setOpen(false);
      },
      onError: error => toast.error(error.response.data.error),
    },
  );

  const handleRollback = useCallback(async () => {
    try {
      const data = {
        project_id: slug,
        version_number: version?.version_number,
        user_id: user.id,
      };

      await rollBack({...data});
    } catch (error) {
      console.log(error);
    }
  }, [rollBack, slug, user.id, version?.version_number]);

  return (
    <div className="w-full">
      <RollbackVersion
        open={open}
        setOpen={setOpen}
        onClick={handleRollback}
        isLoading={rollingBack}
      />
      <div className="bg-white p-2 rounded-lg shadow-sm absolute top-4 left-4">
        <p className="text-body text-sm">
          Version:{' '}
          <span className="text-sm text-grey-200 font-medium">
            {version?.version_number}
          </span>
        </p>
      </div>
      <div className="flex absolute top-0 left-0 right-0 justify-center z-50">
        <div className="bg-white flex gap-8 rounded-lg shadow-sm border border-brandBlue w-fit p-2 px-4">
          <div>
            <p className="text-body text-sm">Viewing flow history</p>
            <p className="text-xs mt-1 text-grey-200">{currentVersion}</p>
          </div>

          <PrimaryButton
            onClick={() => setOpen(!open)}
            yPadding="py-1"
            className="text-xs text-white bg-brandBlue py-1 px-3 rounded-lg"
            buttonText="Rollback Version"
            loading={rollingBack}
          />
        </div>
      </div>
    </div>
  );
}

export default VersionLabel;
